<script>
    export default {
        props: {
            title: {
                type: String,
                default: ""
            },
            value: {
                default: ""
            },
            icon: {
                type: String,
                default: ""
            },
            color: {
              type: String,
              default: "bg-primary"
            },
            background: {
              type: String,
            },
            textColor: {
              type: String,
            }
        }
    };
</script>

<template>
    <div class="card mini-stats-wid" :class="background || ''">
        <div class="card-body">
            <div class="media">
                <div class="media-body">
                    <p class="text-muted font-weight-medium">{{title}}</p>
                    <h4 class="mb-0" :class="{'text-white': textColor}">{{value}}</h4>
                </div>
                <div class="mini-stat-icon avatar-sm align-self-center rounded-circle" :class="color">
                    <span class="d-flex align-items-center justify-content-center h-100">
                      <i :class="`${icon} font-size-24`"></i>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
